export default __webpack_public_path__ + "static/media/controller.c741d442.png";